import http from "../http";

export default class BaseService {
  constructor(resourcePath) {
    this.resourcePath = resourcePath;
  }

  async get(path = "") {
    try {
      // Normalise joins:
      // - if path is empty -> GET resourcePath
      // - if path starts with "?" -> GET resourcePath + "?"
      // - else -> GET resourcePath + "/" + path (without double slashes)
      const base = this.resourcePath.replace(/\/+$/, "");
      const p = String(path || "");

      const url =
        !p
          ? base
          : p.startsWith("?")
          ? `${base}${p}`
          : `${base}/${p.replace(/^\/+/, "")}`;

      const response = await http.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching from ${this.resourcePath}:`, error);
      throw error;
    }
  }

  async create(data) {
    const response = await http.post(this.resourcePath, data);
    return response.data;
  }

  async update(id, data) {
    const response = await http.put(`${this.resourcePath}/${id}`, data);
    return response.data;
  }

  async delete(id) {
    const response = await http.delete(`${this.resourcePath}/${id}`);
    return response.data;
  }

  async post(endpoint = "", data = {}) {
    const base = this.resourcePath.replace(/\/+$/, "");
    const ep = String(endpoint || "");
    const url = !ep ? base : `${base}/${ep.replace(/^\/+/, "")}`;
    const response = await http.post(url, data);
    return response.data;
  }

  async patch(idOrUrl, data = {}) {
    let endpoint;
    if (typeof idOrUrl === "number") endpoint = `${this.resourcePath}/${idOrUrl}`;
    else endpoint = idOrUrl ? `${this.resourcePath}/${idOrUrl}` : this.resourcePath;

    const response = await http.patch(endpoint, data);
    return response.data;
  }
}